/* 使用真实商品变体，继续复用原主题 product-form / cart-drawer。 */
if (!customElements.get('nn-reference-product')) {
  customElements.define('nn-reference-product', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const listen = (target, type, fn) => target?.addEventListener(type, fn, { signal: this.controller.signal });
      this.variants = JSON.parse(this.querySelector('[data-nn-variants]').textContent);
      this.form = this.querySelector('form[data-type="add-to-cart-form"]');
      this.quantity = this.form.querySelector('[name="quantity"]');
      this.querySelector('[data-nn-native-variants]').hidden = true;
      this.querySelector('.nn-deals').hidden = false;
      this.submit = this.form.querySelector('[data-nn-submit]');
      this.dialog = this.querySelector('[data-nn-lightbox]');
      const benefitLabels = this.querySelectorAll('[data-nn-auto-benefits] span');
      const description = this.querySelector('[data-nn-description]');
      if (description && benefitLabels.length) {
        const labels = [...description.querySelectorAll('h2,h3,strong,b')]
          .map(el => el.textContent.replace(/\s+/g, ' ').trim())
          .filter(text => text.length >= 7 && text.length <= 55 && !/^(features?|specifications?|package|product details|note|warning)\s*[:：]?$/i.test(text));
        [...new Set(labels)].slice(0, 4).forEach((text, i) => benefitLabels[i].textContent = text);
      }
      listen(this, 'change', e => {
        if (e.target.name === 'nn_variant') this.selectVariant(e.target.value, true);
      });
      listen(this, 'click', e => {
        const thumb = e.target.closest('[data-nn-thumb]');
        if (thumb) this.showMedia(thumb.dataset.nnThumb);
        const stepButton = e.target.closest('[data-nn-quantity]');
        if (stepButton) {
          const increment = Number(this.quantity.step) || 1;
          const min = Number(this.quantity.min) || 1;
          const max = this.quantity.max ? Number(this.quantity.max) : Infinity;
          this.quantity.value = Math.max(min, Math.min(max, (Number(this.quantity.value) || min) + Number(stepButton.dataset.nnQuantity) * increment));
          this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (e.target.closest('[data-nn-sticky-buy]') && !this.submit.disabled) this.form.requestSubmit(this.submit);
        const zoom = e.target.closest('[data-nn-zoom]');
        if (zoom) {
          const img = zoom.querySelector('img');
          this.dialog.querySelector('img').src = img.currentSrc || img.src;
          this.dialog.querySelector('img').alt = img.alt || this.querySelector('h1').textContent;
          this.dialog.showModal();
        }
        if (e.target.closest('[data-nn-close]') || e.target === this.dialog) this.dialog.close();
      });
      listen(this.querySelector('.nn-thumbnails'), 'keydown', e => {
        if (!['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
        const thumbs = [...this.querySelectorAll('[data-nn-thumb]')];
        const index = thumbs.indexOf(e.target.closest('[data-nn-thumb]'));
        if (index < 0) return;
        e.preventDefault();
        const next = thumbs[(index + (e.key === 'ArrowRight' ? 1 : -1) + thumbs.length) % thumbs.length];
        this.showMedia(next.dataset.nnThumb); next.focus();
      });
      listen(window, 'popstate', () => {
        const id = new URL(location.href).searchParams.get('variant') || this.variants[0].id;
        this.selectVariant(id, false);
      });
      const sticky = this.querySelector('[data-nn-sticky]');
      const purchase = this.querySelector('.nn-buy');
      const updateSticky = () => {
        this.stickyFrame = null;
        sticky.hidden = purchase.getBoundingClientRect().bottom > 0;
      };
      const scheduleSticky = () => {
        if (this.stickyFrame == null) this.stickyFrame = requestAnimationFrame(updateSticky);
      };
      this.observer = new IntersectionObserver(updateSticky, { threshold: 0 });
      this.observer.observe(purchase);
      window.addEventListener('scroll', scheduleSticky, { passive: true, signal: this.controller.signal });
      listen(window, 'resize', scheduleSticky);
      updateSticky();
      this.selectVariant(this.form.querySelector('[name="id"]').value, false);
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.stickyFrame); this.stickyFrame = null; this.controller = null; }
    showMedia(id) {
      const slides = [...this.querySelectorAll('[data-nn-slide]')];
      if (!slides.some(el => el.dataset.nnSlide === String(id))) return;
      slides.forEach(el => {
        el.hidden = el.dataset.nnSlide !== String(id);
        if (el.hidden) el.querySelectorAll('video').forEach(video => video.pause());
      });
      this.querySelectorAll('[data-nn-thumb]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.nnThumb === String(id))));
    }
    selectVariant(id, updateUrl) {
      const variant = this.variants.find(v => String(v.id) === String(id));
      if (!variant) return;
      this.querySelectorAll('[name="nn_variant"]').forEach(input => input.checked = input.value === String(variant.id));
      const input = this.form.querySelector('[name="id"]');
      input.value = variant.id; input.dispatchEvent(new Event('change', { bubbles: true }));
      this.querySelector('[data-nn-price]').textContent = variant.price;
      this.querySelector('[data-nn-sticky-price]').textContent = variant.price;
      const compare = this.querySelector('[data-nn-compare]');
      compare.textContent = variant.compare; compare.hidden = !variant.onSale;
      const percent = this.querySelector('[data-nn-percent]');
      percent.textContent = 'SAVE ' + variant.percent + '%'; percent.hidden = !variant.onSale;
      this.querySelector('[data-nn-saving]').hidden = !variant.onSale;
      this.querySelector('[data-nn-saving-amount]').textContent = variant.saving;
      this.querySelector('[data-nn-availability]').textContent = variant.available ? 'Available to order' : 'Sold out';
      this.querySelector('.nn-availability').classList.toggle('is-sold-out', !variant.available);
      this.submit.disabled = !variant.available;
      this.submit.querySelector('span').textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
      this.submit.removeAttribute('aria-disabled');
      this.querySelector('[data-nn-sticky-buy]').disabled = !variant.available;
      this.querySelector('[data-nn-sticky-buy]').textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
      this.querySelector('.shopify-payment-button')?.toggleAttribute('hidden', !variant.available);
      this.quantity.min = variant.minimum || 1; this.quantity.step = variant.increment || 1;
      if (variant.maximum) this.quantity.max = variant.maximum; else this.quantity.removeAttribute('max');
      const min = Number(this.quantity.min), step = Number(this.quantity.step), max = variant.maximum || Infinity;
      const requested = Math.max(min, Math.min(max, Number(this.quantity.value) || min));
      this.quantity.value = min + Math.floor((requested - min) / step) * step;
      if (variant.media) this.showMedia(variant.media);
      if (updateUrl) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
    }
  });
}
document.querySelectorAll('.nn-country select').forEach(select => {
  select.addEventListener('change', () => select.form.requestSubmit());
});
